import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';

import { Form } from 'formsy-semantic-ui-react';
import 'react-quill/dist/quill.snow.css'; // ES6

import objectId from '../../../../../helpers/objectId';
import TextEditor from '../../../../common/TextEditor';
var moment = require('moment');



class NotesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notes: ''
        }
    }

    close = () => {
        if (this.props.clickStatus === "addNote") {
            this.setState({ notes: '' })
        }
        else if (this.props.clickStatus === "editNote") {
            this.setState({ notes: this.state.notes })
        }
        this.props.notesClick(false, this.props.clickStatus);
    }

    addNotes = () => {
        if (this.props.clickStatus === "addNote") {
            let notesPayload = {
                _id: objectId(),
                content: this.state.notes,
                accountUserId: this.props.user._id,
                notedate: moment()
            }
            if (this.props.string === 'intiativeOverview') {
                let initiativeLog = {
                    "accountUserId" : this.props.user._id,
                    "commentDate" : moment()
                }
                this.props.selectedData.id = this.props.selectedData._id;
                (this.props.selectedData.notes).unshift(notesPayload)
                // dispatch.initiatives.updateInitiative(this.props.selectedData);
                let name = this.props.user.firstName +' '+ this.props.user.lastName;
                initiativeLog.comment = `${name} has added comment.\nComment: ${notesPayload.content}`;
                this.props.selectedData.initativeLogs.unshift(initiativeLog);
                let notificationText = `${name} has added comment in an initiative ${this.props.selectedData.name}.`;
                dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedData._id, notes: this.props.selectedData.notes, initativeLogs: this.props.selectedData.initativeLogs, notificationText:notificationText});
                // dispatch.initiatives.updateInitiativeList({ _id: this.props.selectedDataById._id, data: { name: e.target.value, slug: e.target.value.toLowerCase() } })
                this.props.selectedData.notes[0].accountUserId = this.props.user;
            }
            else if (this.props.string === 'intiativeActivityProgressView') {
                let eventData = {
                    "userId" : this.props.user._id,
                    "initiativeId" : this.props.selectedData.initiativeId._id,
                    "activityId" : this.props.selectedData._id,
                    "event" : "customEvent"
                }
                eventData.type = 'commentAdded';
                let name = this.props.user.firstName +' '+ this.props.user.lastName;
                eventData.notificationText = `${name} has added comment under ${this.props.selectedData.name} in an initiative ${this.props.selectedData.initiativeId.name}`;
                this.props.selectedData.eventData = eventData;
                this.props.selectedData.string = 'commentAdded';
                this.props.selectedData.text = notesPayload.content;
                this.props.selectedData.activityid = this.props.selectedData._id;
                (this.props.selectedData.notes).unshift(notesPayload)
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedData);
            }

            this.close();

        }

        else if (this.props.clickStatus === "editNote") {
            let index = this.props.notes.findIndex(x => x._id === this.props.currentNote._id);
            let notesPayload = {
                _id: this.props.currentNote._id,
                content: this.state.notes ? this.state.notes : this.props.currentNote.content,
                accountUserId: this.props.currentNote.accountUserId,
                notedate: moment()
            }
            this.props.selectedData.notes[index] = notesPayload;

            if (this.props.string === 'intiativeOverview') {
                let initiativeLog = {
                    "accountUserId" : this.props.user._id,
                    "commentDate" : moment()
                }
                let name = this.props.user.firstName +' '+ this.props.user.lastName;
                initiativeLog.comment = `${name} has updated comment.\nComment: ${notesPayload.content}`;
                this.props.selectedData.initativeLogs.unshift(initiativeLog);
                this.props.selectedData.id = this.props.selectedData._id;
                let notificationText = `${name} has updated comment in an initiative ${this.props.selectedData.name}.`;
                // dispatch.initiatives.updateInitiative(this.props.selectedData);
                dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedData._id, notes: this.props.selectedData.notes, initativeLogs: this.props.selectedData.initativeLogs, notificationText:notificationText })
                // this.props.selectedData.notes[this.props.selectedData.notes.length - 1].accountUserId = this.props.user;

            }
            else if (this.props.string === 'intiativeActivityProgressView') {
                let eventData = {
                    "userId" : this.props.user._id,
                    "initiativeId" : this.props.selectedData.initiativeId._id,
                    "activityId" : this.props.selectedData._id,
                    "event" : "customEvent"
                }
                eventData.type = 'commentUpdated';
                let name = this.props.user.firstName +' '+ this.props.user.lastName;
                eventData.notificationText = `${name} has updated comment under ${this.props.selectedData.name} in an initiative ${this.props.selectedData.initiativeId.name}`;
                this.props.selectedData.eventData = eventData;
                this.props.selectedData.string = 'commentUpdated';
                this.props.selectedData.text = notesPayload.content;
                this.props.selectedData.activityid = this.props.selectedData._id;
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedData);
            }
            this.close();
        }

    }

    updateText = (data, name) => {
        if (name === "Note") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ notes: '' })
            } else {
                this.setState({ notes: data })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.currentNote.content !== nextProps.currentNote.content) {
            this.setState({ notes: nextProps.currentNote.content })
        }
        if (nextProps.clickStatus === "addNote") {
            this.setState({ notes: '' })
        }
        else if (nextProps.clickStatus === "editNote") {
            this.setState({ notes: nextProps.currentNote.content })
        }
    }

    render() {
        return (
            <Modal
                className="NotesModalCard basicModal "
                open={this.props.open}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {this.props.clickStatus === "editNote" ? "Edit Comment" : 'Add Comment'}
                </Modal.Header>
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="issue"
                    id="issueid"
                    onValidSubmit={() => { this.addNotes() }}
                >
                    <Modal.Content className="pad_20" scrolling>
                        <span className="head">{this.props.selectedData.name}</span>

                        <TextEditor
                            name="Note"
                            text={this.state.notes}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                            autoFocus={true}
                        />


                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button type="button" content='Cancel' className="button-cancel" onClick={this.close} />
                        {this.props.clickStatus === "editNote" ?
                            <Button type="submit" content='Update' disabled={!this.state.notes || (this.state.notes && this.state.notes.length === 0)} className="button-submit" /> :
                            <Button type="submit" content='Add Comment' disabled={!this.state.notes || (this.state.notes && this.state.notes.length === 0)} className="button-submit" />}
                    </Modal.Actions>
                </Form >
            </Modal>


        )
    }
}



export default NotesModal;